namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    import psga = apigateway.client;
    import psgm = apigateway.models;

    export interface IDebitCardService {
        getDebitCardDetail(memberNumber: string): angular.IPromise< psgm.DebitCardInfoResponseModel>;
        getLashPatientDebitCardLast4(patientLashId: string): angular.IPromise<string>;
    }

    @Service('app', 'debitCardService')
    @Inject('$q', 'EdgeDebitCardApi')
    export class DebitCardService implements IDebitCardService {
        constructor(
            private $q: angular.IQService,
            private edgeDebitCardApi: psga.EdgeDebitCardApi
        ){}

        getDebitCardDetail(memberNumber: string) {
            return this.$q.when(this.edgeDebitCardApi.debitCardGetDebitCardDetail({ memberNumber } as psgm.GetDebitCardDetailRequestModel).then(response => {
                response.data.data.effectiveDate = <moment.Moment><unknown>response.data.data.effectiveDate?.toDate();
                response.data.data.expirationDate = <moment.Moment><unknown>response.data.data.expirationDate?.toDate();
                response.data.data.vmcValidThroughDate = <moment.Moment><unknown>response.data.data.vmcValidThroughDate?.toDate();
                return response.data.data;
            }));
        }

        getLashPatientDebitCardLast4(patientLashId: string) {
            return this.$q.when(this.edgeDebitCardApi.debitCardGetLashPatientDebitCardLast4({ patientLashId }).then(response => {
                return response.data.data;
            }));
        }
    }
}